// extracted by mini-css-extract-plugin
export var resizer = "_ib-0";